// extracted by mini-css-extract-plugin
export var container = "_rj-0";
export var table = "_rj-2";
export var tableWrapper = "_rj-1";